// C:\Users\User\Desktop\Bresco\bresco-franquicies-frontend\src\pages\App.js
import Layout from 'components/layout/Layout'
import { useUser } from 'contexts/UserContext'
import Dashboard from 'pages/Dashboard/Dashboard'
import Login from 'pages/Login/Login'
import Logout from 'pages/Login/Logout'
import PropTypes from 'prop-types'
import { ToastContainer } from 'react-toastify'
import { Redirect, Route, Switch } from 'wouter'

import UserViewDetail from './User/UserViewDetail'
import UserViewGrid from './User/UserViewGrid'

import SiniestrosViewGrid from './Siniestros/SiniestrosViewGrid'
import SiniestrosViewDetail from './Siniestros/SiniestrosViewDetail'
import SiniestroLogsViewGrid from './Siniestros/SiniestroLogsViewGrid'

import FranquiciasViewGrid from './Franquicias/FranquiciasViewGrid'
import FranquiciasViewDetail from './Franquicias/FranquiciasViewDetail'


// Rutas privadas
const PrivateRoute = ({ isLoggedIn, ...props }) =>
  isLoggedIn ? (
    <Layout>
      <Route {...props} />
    </Layout>
  ) : (
    <Redirect to="/login" />
  )

// Ruta login
const LoginRoute = ({ isLoggedIn, ...props }) =>
  isLoggedIn ? <Redirect to="/" /> : <Route path="/login" component={Login} />

export default function App() {
  const { user } = useUser()
  const isLoggedIn = user && !!user.accessToken

  return (
    <>
      <Switch>
        <LoginRoute isLoggedIn={isLoggedIn} path="/login" component={Login} />
        <PrivateRoute isLoggedIn={isLoggedIn} path="/logout" component={Logout} />

        <PrivateRoute isLoggedIn={isLoggedIn} path="/" component={Dashboard} />

        {/* USERS */}
        <PrivateRoute isLoggedIn={isLoggedIn} path="/users/grid" component={UserViewGrid} />
        <PrivateRoute isLoggedIn={isLoggedIn} path="/users/:id" component={UserViewDetail} />

        {/* SINIESTROS */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/siniestros/grid"
          component={SiniestrosViewGrid}
        />
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/siniestros/logs"
          component={SiniestroLogsViewGrid}
        />
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/siniestros/:id"
          component={SiniestrosViewDetail}
        />
        {/* opcional: redirigir /siniestros -> /siniestros/grid */}
        <Route path="/siniestros">
          <Redirect to="/siniestros/grid" />
        </Route>

        {/* FRANQUICIAS */}
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/franquicias/grid"
          component={FranquiciasViewGrid}
        />
        <PrivateRoute
          isLoggedIn={isLoggedIn}
          path="/franquicias/:codigo"
          component={FranquiciasViewDetail}
        />
        {/* opcional: redirigir /franquicias -> /franquicias/grid */}
        <Route path="/franquicias">
          <Redirect to="/franquicias/grid" />
        </Route>

      </Switch>

      <ToastContainer />
    </>
  )
}

PrivateRoute.propTypes = {
  isLoggedIn: PropTypes.bool
}

LoginRoute.propTypes = {
  isLoggedIn: PropTypes.bool
}
